export default __webpack_public_path__ + "static/media/wolf.7136fd2c.svg";